<div class="container-fluid page mb-3">
  <app-intelligence></app-intelligence>
  <app-accession></app-accession>
  <app-reports></app-reports>
</div>
